module.exports = __webpack_public_path__ + "img/cave-vin-blanc-en-ligne-boutrais-small.5c6fede0.png";